module.exports = __webpack_public_path__ + "img/tanzania,-united-republic-of.4d03c5ac.svg";